export default "__VITE_ASSET__CVwBfWZv__"